import '../../utils/index.mjs';
import _sfc_main from './src/alert2.mjs';
export { alertEffects, alertEmits, alertProps } from './src/alert.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAlert = withInstall(_sfc_main);

export { ElAlert, ElAlert as default };
//# sourceMappingURL=index.mjs.map
